import React, {useEffect, useState} from 'react'
import {Table} from 'antd'
import {correctedURL} from '../../utilities'
import FileUploader from '../../FileHandling/FileUploader'
import {helperMessage} from './helperMessage'
import {submit} from './submit'
import {makeColumns} from './columns'
import StatusDisplay from './StatusDisplay'

export default function TopLevelState({project}) {
  const [files, setFiles] = useState({})
  const [namesList, setNamesList] = useState([])
  const [statuses, setStatuses] = useState({})

  useEffect(
    function () {
      const filesListTemp = []
      const pp = (project.intake.files || []).map((file) => {
        if (!file.fullPath) return null
        //console.log('file.fullPath', namesList.includes(file.name))
        filesListTemp.push(file.name)
        const url = correctedURL(file.fullPath)
        file.url = url
        return file
      })
      let s = new Set(filesListTemp);
      setNamesList([...s])
      setFiles(pp)
    },
    [project.intake.files]
  )

  function updateStatus(newStatus) {
    setStatuses({...statuses, ...newStatus})
  }

  let k = 0
  const dataSource = Object.entries(files).map(([id, file]) => ({...file, key: ++k, id}))
  const columns = makeColumns(project.id)
  console.log('namesList', namesList)

  return (
    <div className="background-white margin-top-2">
      <StatusDisplay statuses={statuses.statuses} />
      <h3 className="padding-2 margin-0" style={{borderBottom: '0.1rem solid #DFE3E8'}}>
        Uploaded Documents
      </h3>
      <div className="padding-1">
        <Table {...{dataSource, columns}} />
      </div>
      <div className="padding-2">
        <FileUploader
          collection="projects"
          id={project.id}
          type="file"
          updateStatus={updateStatus}
          helperMessage={helperMessage}
          submit={submit(updateStatus, project.id)}
          existedFiles={namesList}
          skipDuplicates={true}
        />
      </div>
    </div>
  )
}
